import React, { useEffect } from 'react';
import Header from '../../components/Header';
import HeroSection from './components/HeroSection';
import IntegrationFeatures from './components/IntegrationFeatures';
import TechnicalCapabilities from './components/TechnicalCapabilities';
import IntegrationProcess from './components/IntegrationProcess';
import PlatformShowcase from './components/PlatformShowcase';
import CaseStudies from './components/CaseStudies';
import IntegrationTemplates from './components/IntegrationTemplates';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import Footer from '../../components/Footer';
import { Helmet } from 'react-helmet-async';


const CustomAPIIntegrations: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Custom API Integrations | Make Mind Automations';
  }, []);

  return (
    <>
      <Helmet>
  <title>Custom API Integrations & Backend Automation | Make Mind Automations</title>
  <meta
    name="description"
    content="Connect your CRM, marketing tools, billing systems, and internal apps with robust API integrations. We design secure, scalable Make.com and n8n workflows tailored to your business."
  />
  <meta
    name="keywords"
    content="custom API integrations, automation API, backend workflows, CRM integration, SaaS integration, n8n API, Make.com API"
  />
  <link
    rel="canonical"
    href="https://www.makemindautomations.tech/custom-api-integrations"
  />
</Helmet>


      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <HeroSection />
          <IntegrationFeatures />
          <TechnicalCapabilities />
          <IntegrationProcess />
          <PlatformShowcase />
          <CaseStudies />
          <IntegrationTemplates />
          <Testimonials />
          <FAQ />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default CustomAPIIntegrations;